(function() {
  var initialized = 'data-cart-document-initialized';
  var typingTimer = null;

  function getDocumentType(wrapper) {
    var checked = wrapper.querySelector('.document-type-selector:checked');

    return checked ? checked.value : 'boleta';
  }

  function getForm(wrapper) {
    return wrapper.closest('form');
  }

  function cleanRut(value) {
    return String(value || '').replace(/\./g, '').replace(/-/g, '').trim();
  }

  function validateRut(wrapper) {
    var rut = wrapper.querySelector('[data-cart-document-rut]');
    var value = cleanRut(rut ? rut.value : '');
    var body = value.slice(0, -1);
    var dv = value.slice(-1).toUpperCase();
    var sum = 0;
    var multiple = 2;
    var expectedDv = 0;
    var normalizedDv = dv;

    if (!rut) {
      return true;
    }

    if (getDocumentType(wrapper) != 'factura') {
      rut.classList.add('valido');
      rut.classList.remove('invalido');
      rut.setCustomValidity('');
      return true;
    }

    if (value != '') {
      rut.value = body + '-' + dv;
    }

    if (body.length < 7) {
      rut.classList.add('invalido');
      rut.classList.remove('valido');
      rut.setCustomValidity('RUT Incompleto');
      return false;
    }

    for (var i = 1; i <= body.length; i += 1) {
      sum += multiple * value.charAt(body.length - i);
      multiple = multiple < 7 ? multiple + 1 : 2;
    }

    expectedDv = 11 - (sum % 11);
    normalizedDv = normalizedDv == 'K' ? 10 : normalizedDv;
    normalizedDv = normalizedDv == 0 ? 11 : normalizedDv;

    if (expectedDv != parseInt(normalizedDv, 10)) {
      rut.classList.add('invalido');
      rut.classList.remove('valido');
      rut.setCustomValidity('RUT Inválido');
      return false;
    }

    rut.classList.add('valido');
    rut.classList.remove('invalido');
    rut.setCustomValidity('');
    return true;
  }

  function validateTextFields(wrapper) {
    var valid = true;

    wrapper.querySelectorAll('[data-cart-document-field]').forEach(function(input) {
      if (getDocumentType(wrapper) == 'factura' && input.value.trim() == '') {
        input.setCustomValidity('Campo obligatorio');
        valid = false;
      } else {
        input.setCustomValidity('');
      }
    });

    return valid;
  }

  function validateDocument(wrapper, showError) {
    var valid = true;

    if (getDocumentType(wrapper) == 'factura') {
      valid = validateRut(wrapper) && validateTextFields(wrapper);
    } else {
      validateRut(wrapper);
      validateTextFields(wrapper);
    }

    wrapper.classList.toggle('has-error', showError && !valid);
    return valid;
  }

  function updateCheckoutState(wrapper, showError) {
    var form = getForm(wrapper);
    var button = form ? form.querySelector('button[name="checkout"]') : null;
    var valid = validateDocument(wrapper, showError);
    var terms = form ? form.querySelector('[data-cart-acceptance-checkbox]') : null;

    if (!button) {
      return valid;
    }

    if (valid && (!terms || terms.checked)) {
      button.removeAttribute('disabled');
    } else {
      button.setAttribute('disabled', 'disabled');
    }

    return valid;
  }

  function updateRequiredState(wrapper, clearFields) {
    var isFactura = getDocumentType(wrapper) == 'factura';
    var billingMenu = wrapper.querySelector('.billing-menu');
    var fields = wrapper.querySelectorAll('[data-cart-document-rut], [data-cart-document-field]');

    if (billingMenu) {
      billingMenu.classList.toggle('show', isFactura);
    }

    fields.forEach(function(input) {
      input.required = isFactura;

      if (!isFactura) {
        input.setCustomValidity('');
        input.classList.remove('invalido');

        if (clearFields) {
          input.value = '';
          input.classList.remove('valido');
        }
      }
    });

    updateCheckoutState(wrapper, false);
  }

  function cartAttributes(wrapper) {
    var attributes = {
      'shoppingcart-tags': getDocumentType(wrapper),
      RUT: '',
      razon: '',
      giro: ''
    };
    var rut = wrapper.querySelector('[name="attributes[RUT]"]');
    var razon = wrapper.querySelector('[name="attributes[razon]"]');
    var giro = wrapper.querySelector('[name="attributes[giro]"]');

    if (attributes['shoppingcart-tags'] == 'factura') {
      attributes.RUT = rut ? rut.value : '';
      attributes.razon = razon ? razon.value : '';
      attributes.giro = giro ? giro.value : '';
    }

    return attributes;
  }

  function saveAttributes(wrapper) {
    var updateUrl = window.theme && window.theme.routes ? window.theme.routes.cart_update_url : '/cart/update.js';

    return fetch(updateUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        attributes: cartAttributes(wrapper)
      })
    });
  }

  function saveAttributesDebounced(wrapper) {
    clearTimeout(typingTimer);
    typingTimer = setTimeout(function() {
      saveAttributes(wrapper);
    }, 350);
  }

  function reportDocumentValidity(wrapper) {
    var firstInvalid = wrapper.querySelector(':invalid');

    validateDocument(wrapper, true);

    if (firstInvalid) {
      firstInvalid.reportValidity();
    }
  }

  function initDocument(wrapper) {
    var form = getForm(wrapper);

    if (wrapper.hasAttribute(initialized)) {
      return;
    }

    wrapper.setAttribute(initialized, 'true');
    updateRequiredState(wrapper, false);

    wrapper.querySelectorAll('.document-type-selector').forEach(function(input) {
      input.addEventListener('change', function() {
        updateRequiredState(wrapper, input.value == 'boleta');
        saveAttributes(wrapper);
      });
    });

    wrapper.querySelectorAll('[data-cart-document-rut], [data-cart-document-field]').forEach(function(input) {
      input.addEventListener('input', function() {
        updateCheckoutState(wrapper, false);
        saveAttributesDebounced(wrapper);
      });

      input.addEventListener('blur', function() {
        updateCheckoutState(wrapper, false);
        saveAttributes(wrapper);
      });
    });

    if (form) {
      form.addEventListener('submit', function(event) {
        var submitter = event.submitter;

        if (submitter && submitter.name != 'checkout') {
          return;
        }

        if (!submitter && !form.querySelector('button[name="checkout"]')) {
          return;
        }

        if (!updateCheckoutState(wrapper, true)) {
          event.preventDefault();
          reportDocumentValidity(wrapper);
        }
      });
    }
  }

  document.addEventListener('click', function(event) {
    var link = event.target.closest('.cart__view');
    var wrapper = document.querySelector('[data-cart-document]');

    if (!link || !wrapper) {
      return;
    }

    event.preventDefault();
    saveAttributes(wrapper).finally(function() {
      window.location.href = link.href;
    });
  });

  function initDocuments() {
    document.querySelectorAll('[data-cart-document]').forEach(initDocument);
  }

  document.addEventListener('DOMContentLoaded', initDocuments);
  document.addEventListener('shopify:section:load', initDocuments);
  document.addEventListener('theme:cart-drawer:open', initDocuments);
  document.addEventListener('theme:cart:refresh', initDocuments);
})();
